var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEsg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_52281_36893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.71875 17.7921H14.2435C14.6802 17.7921 15.099 17.6187 15.4077 17.3099C15.7165 17.0011 15.89 16.5824 15.89 16.1457V5.76275C15.89 5.55874 15.8089 5.36308 15.6646 5.21882L11.9993 1.55343C11.855 1.40917 11.6593 1.32812 11.4553 1.32812H4.36515C3.9285 1.32813 3.50973 1.50158 3.20097 1.81034C2.89221 2.1191 2.71875 2.53787 2.71875 2.97453V8.20183",
    stroke: "#67768E",
    strokeWidth: 1.15385,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.29311 9.93441C4.88595 9.82308 4.45702 9.79811 4.03436 9.8647C3.35618 9.97155 2.73513 10.3077 2.27477 10.817C1.81441 11.3263 1.54258 11.9781 1.5046 12.6635C1.46662 13.349 1.66479 14.0268 2.06606 14.5839C2.46733 15.141 3.04745 15.5436 3.70967 15.7247C4.37189 15.9059 5.07619 15.8545 5.70511 15.5792C6.33403 15.3038 6.84956 14.8212 7.16572 14.2118C7.34668 13.863 7.45607 13.4848 7.49083 13.0989",
    stroke: "#67768E",
    strokeWidth: 1.15385,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.59375 12.5307L4.49419 13.4312L7.49566 10.4297",
    stroke: "#67768E",
    strokeWidth: 1.15385,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.84375 3.96094H7.84375",
    stroke: "#67768E",
    strokeWidth: 1.15385,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.84375 6.03906H8.84375",
    stroke: "#67768E",
    strokeWidth: 1.15385,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_52281_36893"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsg);
export default __webpack_public_path__ + "static/media/esg.5e152a38987f0d448ff2dd7441b4cbe2.svg";
export { ForwardRef as ReactComponent };